<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-overlay :show="loading">
                        <b-row>
                            <b-col xl="12" lg="12" sm="12">
                                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                                    <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                                        <b-row>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Organization Name" vid="org_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="org_id "
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                        {{$t('ds_institute_management.organization_name')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                        plain
                                                        v-model="dataArray.org_id"
                                                        id="org_id"
                                                        :options="orgList"
                                                        :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                        {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="fiscal_year_id"
                                                        slot-scope="{ valid, errors }"
                                                        >
                                                        <template v-slot:label>
                                                            {{ $t('globalTrans.fiscal_year') }} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-select
                                                            plain
                                                            v-model="dataArray.fiscal_year_id"
                                                            id="fiscal_year_id"
                                                            :options="fiscalYearList"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        <template v-slot:first>
                                                            <b-form-select-option :value="0" disabled>{{$t('globalTrans.select')}}</b-form-select-option>
                                                        </template>
                                                        </b-form-select>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Total num of training course" vid="total_num_of_training_course" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="total_num_of_training_course"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{$t('tp_management.total_num_of_training_course')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            plain
                                                            v-model="dataArray.total_num_of_training_course"
                                                            id="total_num_of_training_course"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Total num of refreshers course" vid="total_num_of_refreshers_course" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="total_num_of_refreshers_course"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{$t('tp_management.total_num_of_refreshers_course')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            plain
                                                            v-model="dataArray.total_num_of_refreshers_course"
                                                            id="total_num_of_refreshers_course"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Total receive amount" vid="total_receive_amount" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="total_receive_amount"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{$t('tp_management.total_receive_amount')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            plain
                                                            @input="calculateRestAmount"
                                                            v-model="dataArray.total_receive_amount"
                                                            id="total_receive_amount"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Total Cost" vid="total_cost" :rules="`required|max_value:${parseFloat(dataArray.total_receive_amount ? dataArray.total_receive_amount : 0)}`">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="total_cost"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{$t('tp_management.total_cost')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            plain
                                                            @input="calculateRestAmount"
                                                            v-model="dataArray.total_cost"
                                                            id="total_cost"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                            <b-col lg="6" sm="12">
                                                <ValidationProvider name="Rest Amount" vid="rest_amount" rules="required">
                                                    <b-form-group
                                                        class="row"
                                                        label-cols-sm="5"
                                                        label-for="rest_amount"
                                                        slot-scope="{ valid, errors }"
                                                    >
                                                        <template v-slot:label>
                                                        {{$t('tp_management.rest_amount')}} <span class="text-danger">*</span>
                                                        </template>
                                                        <b-form-input
                                                            plain
                                                            disabled
                                                            v-model="dataArray.rest_amount"
                                                            id="rest_amount"
                                                            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');"
                                                            :state="errors[0] ? false : (valid ? true : null)"
                                                        >
                                                        </b-form-input>
                                                        <div class="invalid-feedback">
                                                            {{ errors[0] }}
                                                        </div>
                                                    </b-form-group>
                                                </ValidationProvider>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <table class="table table-bordered">
                                                <thead style="background-color: #e0e0de">
                                                    <tr style="background-color: #e0e0de">
                                                        <th width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                                        <th>{{ $t('application_management.document') }} {{$t('elearning_config.name')}} {{ dataArray.details.length }}</th>
                                                        <th>{{ $t('application_management.attachment') }}</th>
                                                        <th>{{ $t('globalTrans.action') }}</th>
                                                    </tr>
                                                </thead>
                                                <b-tr v-for="(item, index) in dataArray.details" :key="index">
                                                    <td>{{ $n(index + 1) }}</td>
                                                    <td>
                                                        <keep-alive>
                                                            <ValidationProvider :vid="'document_name' + index" rules="required" name="Document name">
                                                                <div slot-scope="{ valid, errors }">
                                                                    <b-form-input
                                                                    rows="2"
                                                                    v-model="item.document_name"
                                                                    id="index"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                    ></b-form-input>
                                                                    <div class="error invalid-feedback" role="alert">
                                                                        {{ errors[0] }}
                                                                    </div>
                                                                </div>
                                                            </ValidationProvider>
                                                        </keep-alive>
                                                    </td>
                                                    <b-td style="vertical-align:middle">
                                                        <ValidationProvider :vid="'attachment_name' + index" :rules="id ? '' : 'required'" name="Attachment name">
                                                            <div slot-scope="{ valid, errors }">
                                                                <b-form-file
                                                                    :id="'attachment'+index"
                                                                    v-model="item.attachment_name"
                                                                    @change="changeImage($event, item.id)"
                                                                    :state="errors[0] ? false : (valid ? true : null)"
                                                                >
                                                                </b-form-file>
                                                                <div class="error invalid-feedback" role="alert">
                                                                    {{ errors[0] }}
                                                                </div>
                                                            </div>
                                                        </ValidationProvider>
                                                    </b-td>
                                                    <b-td style="vertical-align:middle">
                                                        <button v-if="dataArray.details.length !== 1" type="button" @click="deleteItem(index, item)" class="btn btn- iq-bg-danger btn-sm"><i class="ri-delete-bin-line m-0"></i></button>
                                                    </b-td>
                                                </b-tr>
                                                <b-tr>
                                                    <td colspan="3"></td>
                                                    <td colspan="2">
                                                    <button
                                                        @click="addMore"
                                                        class="btn btn-sm btn-primary float-right"
                                                        type="button"
                                                    >{{$t('globalTrans.add')}}</button>
                                                    </td>
                                                </b-tr>
                                            </table>
                                        </b-row>
                                        <b-row>
                                            <b-col lg="12" sm="12" md="12">
                                                <b-form-group
                                                    class="row"
                                                    label-cols-sm="2"
                                                    label-for="remarks"
                                                >
                                                    <template v-slot:label>
                                                    {{$t('application_management.remarks')}}
                                                    </template>
                                                    <b-form-textarea
                                                        id="remarks"
                                                        v-model="dataArray.remarks"
                                                        rows="1"
                                                        max-rows="2"
                                                    ></b-form-textarea>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                        <br>
                                        <div class="row">
                                            <div class="col-sm-3"></div>
                                            <div class="col text-right">
                                                <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                                                &nbsp;
                                                <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                                            </div>
                                        </div>
                                    </b-form>
                                </ValidationObserver>
                            </b-col>
                        </b-row>
                    </b-overlay>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
import { budgetManagementStoreApi, budgetManagementUpdateApi } from '../../api/routes'

export default {
    props: ['id'],
    components: {
        ValidationObserver,
        ValidationProvider
    },
    created () {
        this.dataArray.org_id = this.$store.state.dataFilters.orgId
        if (this.id) {
            const tmp = this.getBudgetManagementData()
            const details = tmp.details.map(el => {
                if (el.attachment) {
                    return Object.assign({}, el, { file: el.attachment, attachment: '', attId: el.id })
                } else {
                    return Object.assign({}, el, { file: '', attachment: '', attId: el.id })
                }
            })
            this.dataArray = tmp
            this.dataArray.details = []
            this.dataArray.details = details
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
            dataArray: {
                fiscal_year_id: 0,
                org_id: 0,
                total_num_of_training_course: '',
                total_num_of_refreshers_course: '',
                total_receive_amount: '',
                total_cost: '',
                rest_amount: '',
                remarks: '',
                details: [
                    {
                        id: 1,
                        document_name: null,
                        attachment: '',
                        file: ''
                    }
                ]
            },
            loading: false
        }
    },
    computed: {
        fiscalYearList: function () {
            return this.$store.state.commonObj.fiscalYearList.map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0).map(item => {
                if (this.$i18n.locale === 'bn') {
                    return { value: item.value, text: item.text_bn }
                } else {
                    return { value: item.value, text: item.text_en }
                }
            })
        },
        currentLocale () {
            return this.$i18n.locale
        }
    },
    watch: {
    },
    methods: {
        calculateRestAmount () {
            if (parseFloat(this.dataArray.total_receive_amount) && parseFloat(this.dataArray.total_cost)) {
                this.dataArray.rest_amount = parseFloat(this.dataArray.total_receive_amount) - parseFloat(this.dataArray.total_cost)
            } else {
                this.dataArray.rest_amount = ''
            }
        },
        deleteItem (index) {
            this.dataArray.details.splice(index, 1)
        },
        addMore () {
            this.dataArray.details.push({
                id: this.dataArray.details.length + 1,
                document_name: null,
                attachment: '',
                file: ''
            })
        },
        changeImage (e, id) {
            const input = e.target
            if (input.files && input.files[0]) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    const item = this.dataArray.details.find(item => item.id === id)
                    item.attachment = e.target.result
                }
                reader.readAsDataURL(input.files[0])
            } else {
                this.dataArray.details.attachment = ''
            }
        },
        async saveData () {
            this.loading = true
            this.$store.dispatch('mutateCommonProperties', { loading: true })
            let result = null
            const loadingState = { loading: false, listReload: false }
            if (this.id) {
                result = await RestApi.putData(trainingElearningServiceBaseUrl, `${budgetManagementUpdateApi}/${this.id}`, this.dataArray)
            } else {
                result = await RestApi.postData(trainingElearningServiceBaseUrl, budgetManagementStoreApi, this.dataArray)
            }
            loadingState.listReload = true
            this.$store.dispatch('mutateCommonProperties', loadingState)
            this.loading = false
            if (result.success) {
                this.$toast.success({
                    title: this.$t('globalTrans.success'),
                    message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                    color: '#D6E09B'
                })
                this.$bvModal.hide('modal-4')
            } else if (result.code === 403) {
                this.$toast.error({
                    title: this.$t('globalTrans.error'),
                    message: result.message,
                    color: '#D6E09B'
                })
            } else {
                this.$refs.form.setErrors(result.errors)
            }
        },
        getBudgetManagementData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        }
    }
}

</script>
